var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3.329,
    strokeWidth: 2,
    d: "M11.3079 1.74122C11.5645 1.12645 12.4355 1.12645 12.6921 1.74122L15.1486 7.62582C15.2512 7.87151 15.4763 8.04441 15.7401 8.08012L22.2042 8.95501C22.8544 9.043 23.0862 9.86449 22.5778 10.2793L17.5825 14.3557C17.361 14.5364 17.2615 14.8273 17.326 15.1058L18.9233 22.0084C19.0784 22.6786 18.3248 23.1866 17.7618 22.7914L12.4309 19.0499C12.1723 18.8684 11.8277 18.8684 11.5691 19.0499L6.23816 22.7915C5.67513 23.1866 4.92154 22.6787 5.07661 22.0085L6.67384 15.1058C6.73829 14.8273 6.63881 14.5364 6.41734 14.3557L1.42213 10.2793C0.913805 9.86449 1.14555 9.04301 1.79572 8.95501L8.25985 8.08012C8.52368 8.04441 8.74881 7.87151 8.85137 7.62582L11.3079 1.74122Z",
    className: "colorBFCC94 svgShape colorStrokeBFCC94 svgStroke color00aeae colorStroke00aeae"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/star-white.d82bd8c924a5bd69379752e9db8ceed5.svg";
export { ForwardRef as ReactComponent };